'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { createFetchByIds, createSearchSubmissionTags, fetchByIds, searchSubmissionTag } from '../api/SubmissionTagApi';
export const createSubmissionTagReferenceResolver = options => {
  return createBatchedReferenceResolver(Object.assign({
    cacheKey: CacheKeys.SUBMISSION_TAG,
    createFetchByIds: opts => createFetchByIds(opts),
    createFetchSearchPage: createSearchSubmissionTags,
    fetchByIds,
    fetchSearchPage: searchSubmissionTag
  }, options));
};
export default createSubmissionTagReferenceResolver();